import { carouselData } from '@/mocks/gossipData';

export default function Carousel() {
  return (
    <section id="carousel" className="py-14 md:py-20 px-4 md:px-6 bg-background-100">
      <div className="max-w-7xl mx-auto">
        <div className="text-center mb-10 md:mb-14">
          <h2 className="text-2xl md:text-4xl font-heading text-foreground-950 mb-3">
            焦点专题
          </h2>
          <p className="text-foreground-500 text-base">深度解读娱乐圈热点事件</p>
        </div>

        <div className="flex flex-wrap justify-center gap-5 md:gap-6">
          {carouselData.map((item, i) => (
            <div
              key={i}
              className="group bg-background-50 rounded-2xl overflow-hidden border border-background-200/70 hover:border-primary-200 transition-all duration-300 cursor-default w-full sm:w-[calc(50%-12px)] lg:w-[calc(33.333%-16px)] xl:w-[calc(20%-20px)] min-w-[260px]"
            >
              <div className="relative w-full aspect-[16/10] overflow-hidden">
                <img
                  src={item.img}
                  alt={item.title}
                  className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                />
                <div className="absolute top-3 left-3">
                  <span className="inline-flex items-center px-3 py-1 rounded-full bg-primary-500 text-white text-xs font-medium whitespace-nowrap">
                    {item.tag}
                  </span>
                </div>
              </div>
              <div className="p-4 md:p-5">
                <h3 className="text-sm md:text-base font-heading text-foreground-900 mb-2 line-clamp-2 leading-snug group-hover:text-primary-600 transition-colors">
                  {item.title}
                </h3>
                <p className="text-xs md:text-sm text-foreground-500 leading-relaxed line-clamp-2">
                  {item.desc}
                </p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}